import React from 'react'
import { Button, Carousel, Container, Image } from 'react-bootstrap'
import chairTable from '../../assets/white-bg-chair-table.webp'
import orangeChair from '../../assets/white-bg-orange-chair-2.webp'
import tablet from '../../assets/tablet.webp'
import { Link } from 'react-router-dom'

const CarouselComponent = () => {
  return (

  <Carousel fade>
    <Carousel.Item>
      <Image
        style={{height:"100vh",objectFit: "cover"}}
        className="d-block w-100"
        src={orangeChair}
        alt="First slide"
        />
      <Carousel.Caption 
        style={{display:"flex", flexDirection: "column", position:"absolute", top:"20%", alignItems:"flex-start", textAlign:"start" }}
        >
        <h3 
          className='text-black-50 fw-bold display-1'
          >
          Check out the admin page <span className='text-info'>.</span> 
        </h3>
        <p className='text-black fs-4 mt-3'>
          You can edit parts of the website and check out useful analytics.
        </p>
        <Link to="/admin">
          <Button className='mt-5 fs-4' variant='outline-dark p-3'>
            Go to Admin
          </Button>
        </Link>
      </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
      <Image
        style={{height:"100vh", objectFit: "cover"}}
        className="d-block w-100"
        src={tablet}
        alt="Second slide"
        />
  
        <Carousel.Caption style={{display:"flex", flexDirection: "column", position:"absolute", top:"20%", alignItems:"flex-start", textAlign:"start" }}>
        <h3 
          style={{textAlign:"start"}} 
          className='text-dark-50 fw-bold display-1'
        >
          Sign in and get shopping <span className='text-warning'>.</span>
        </h3>
        <p className='text-light fs-4 mt-3'>
          Enjoy the shopping experience with additional discounts and benefits.
        </p>
        <Link to="/sign-in">
          <Button className='mt-5 fs-4' variant='outline-dark p-3'>
            Sign In
          </Button>
        </Link>
      </Carousel.Caption>
    </Carousel.Item>
    <Carousel.Item>
      <Image
        style={{height:"100vh", objectFit: "cover"}}
        className="d-block w-100"
        src={chairTable}
        alt="Third slide"
      />
  
        <Carousel.Caption style={{display:"flex", flexDirection: "column", position:"absolute", top:"20%", alignItems:"flex-start", textAlign:"start" }}>
        <h3 
          className='text-black-50 fw-bold display-1'
        >
          Sign up now <span className='text-success'>.</span>
        </h3>
        <p className='text-black fs-4 mt-3'>
          Enjoy a more personalized and effortless shopping experience.
        </p>
        <Link to="/sign-up">
          <Button className='mt-5 fs-4' variant='outline-dark p-3'>
            Sign Up
          </Button>
        </Link>
      </Carousel.Caption>
    </Carousel.Item>
  </Carousel>
  )
}

export default CarouselComponent